export enum VehiclePageTab {
  Overview = 'overview',
  Holdings = 'holdings',
  Onboarding = 'onboarding',
}
